import React, { useState } from "react";
import PropTypes from "prop-types";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import Leaflet from "leaflet";
import MarkerClusterGroup from "react-leaflet-markercluster";
import { OPPORTUNITY } from "../../helpers/dummies";

const Maper = ({
  items,
  icon,
  size,
  withPopup,
  redirectLink,
  redirectParam,
  displayAttribute,
  className
}) => {
  const [activeMarker, setActiveMarker] = useState(null);
//  console.log({items})
  const customMarkerIcon = new Leaflet.Icon({
    iconUrl: icon,
    iconSize: [50, 50],
  });

  const createClusterCustomIcon = (cluster) => {
    return new Leaflet.divIcon({
      html: `<span>${cluster.getChildCount()}</span>`,
      className: "custom-cluster",
      iconSize: Leaflet.Point(40, 40, true),
    });
  };

  const onPopupOpened = (item) => {
    setActiveMarker((prevActiveMarker) =>
      prevActiveMarker?.publicId === item.publicId ? null : item
    );
  };

  const onPopupClosed = () => {
    setActiveMarker(null);
  };

    console.log("items",{items})
 
  return (
    <MapContainer
      // center={Array.isArray(items) ? [20.593683, 78.962883] : [items.coordinates.lat, items.coordinates.lng]}
      // zoom={5}
      // scrollWheelZoom={false} 
      // zoomControl={false}
      // className={className}
      center={
        Array.isArray(items) ? 
        [46.181670, 6.122346] : 
        // [items?.school?.latitude, items?.school?.longitude]
        [items.coordinates.lat, items.coordinates.lng]
        }
      zoom={4}
      scrollWheelZoom={false}
      zoomControl={true}
      className={className}
      // icon={icon}
      
    >
      <TileLayer
        url="https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png"
        attribution='&copy; OpenStreetMap France | &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
     
      {Array.isArray(items) ? (
        <MarkerClusterGroup
          showCoverageOnHover={false}
          spiderfyDistanceMultiplier={2}
          iconCreateFunction={createClusterCustomIcon}
        >
          {items.map((item, index) => (
            <Marker
              key={`map_marker_${index}`}
              // position={item.coordinates || [OPPORTUNITY.coordinates.lat, OPPORTUNITY.coordinates.lng]}
              position={item.coordinates || [(item && item.school && item.school.latitude) || 46.181670, (item && item.school && item.school.longitude) || 6.122346]}
              icon={customMarkerIcon}
              eventHandlers={
                withPopup
                  ? {
                      click: () => onPopupOpened(item),
                    }
                  : {}
              }
            />
          ))}
          {withPopup && activeMarker && (
            <Popup
              position={activeMarker.coordinates || [OPPORTUNITY.coordinates.lat, OPPORTUNITY.coordinates.lng]}
              onClose={onPopupClosed}
            >
              <div className="popup-box">
                {activeMarker.image && (
                  <img
                    src={activeMarker.image}
                    className="popup-content"
                    alt="marker popup"
                  />
                )}
                <a
                  href={`${redirectLink}${
                    activeMarker[redirectParam] !== "" ? `/${activeMarker[redirectParam]}` : ""
                  }`}
                >
                  <h6 className="fw-bold text-green p-3 pb-0">
                    {activeMarker[displayAttribute]}
                  </h6>
                </a>
              </div>
            </Popup>
          )}
        </MarkerClusterGroup>
      ) : (
        <Marker
          position={[items.coordinates.lat, items.coordinates.lng]}
          icon={customMarkerIcon}
          eventHandlers={{}}
        />
       
   
      )} 
    </MapContainer>
  );
};

   //   <Marker
      //   position={[items.school.latitude, items.school.longitude]}
      //   icon={customMarkerIcon}
      //   eventHandlers={{}}
      // />

Maper.propTypes = {
  items: PropTypes.any.isRequired,
  icon: PropTypes.any,
  withPopup: PropTypes.bool,
  redirectLink: PropTypes.string,
  redirectParam: PropTypes.string,
  displayAttribute: PropTypes.string,
  size: PropTypes.string,
};

Maper.defaultProps = {
  withPopup: false,
  size: "500",
  displayAttribute: "name",
  redirectLink: "#",
  redirectParam: "publicId",
};

export default Maper;
